export class StockLevelModel {
  prd_code:string
  plant:string
  whs_code:string
  whs_desc:string
  stock_amount:string = "0"
  default_plant:string
  default_whs_code:string
}



// WEBPACK FOOTER //
// ./src/models/product/stocklevel.model.ts